<template>
  <div>
    <BasePopup v-model="isContactUpdatePopupOpen" customClass="custom-popup full mx-wd880 contact-bulkreg">
      <div class="popup-header">
        <h3 class="title">연락처 대량 등록</h3>
        <button type="button" class="btn-cancel" @click="handleClose"></button>
      </div>
      <div class="popup-body">
        <div class="tab-area v2">
          <ul class="tab-list">
            <li v-for="(item, idx) in messageListTab.v2.items" 
              :key="idx"
              class="tab-item" 
              :class="{ active: messageListTab.v2.activeIndex === idx }">
              <button class="tab-btn" @click.prevent="handleTabClick('v2', idx)">
                <span class="tab-text">{{ item.text }}</span>
              </button>
            </li>
          </ul>
        </div>
        <template v-if="messageListTab.v2.activeIndex === 0">
          <div class="contents-title-wrap mt40 mb15">
            <div class="contents-title">
              <HconCheckBox type="checkTitle" :checked="checkedAll" @change="changeCheckedAll" label="선택" :num="checkedAllCount" :unit="'명'" name="allCheckBtn" labelClass="top-check-title" :hide-label="false" />
            </div>
            <div class="rgt-area">
              <span class="total text-gray">총 <em class="count-num">{{ excelSuccessList.length }}</em>명</span>
              <span class="text-gray02">(최대 <span class="count-num">1,000</span>명)</span>
            </div>
          </div>
          <div :class="excelSuccessScrollList.length > 0 && isTableLoading === false ? 'pr10' : ''">
            <table class="tbl-type2">
              <caption>등록 가능한 연락처 목록</caption>
              <colgroup>
                <col style="width:6%;" />
                <col style="width:5%;"/>
                <col style="width:30%;"/>
                <col style="width:14%;"/>
                <col style="width:auto;"/>
                <col style="width:12%;"/>
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" class="xs"></th>
                  <th scope="col" class="xs">No</th>
                  <th scope="col" class="xs">연락처 그룹</th>
                  <th scope="col" class="xs">이름</th>
                  <th scope="col" class="xs">휴대전화번호</th>
                  <th scope="col" class="xs">삭제</th>
                </tr>
              </thead>
            </table>
          </div>
          <!-- 스크롤 영역 s -->
          <div class="relative pb1" :class="[isTableLoading === true || excelSuccessScrollList.length > 0 ? 'scroll scroll1' : 'hg185', {'isChkError': isChkError}]" ref="container0" @scroll="onScroll">
            <table class="tbl-type2" :class="excelSuccessScrollList.length > 0 && isTableLoading === false ? '' : 'h100p'" :style="{ transform: `translateY(${messageListTab.v2.activeIndex === 0 ? vScroll0.offset.value : 0}px)`, tableLayout: 'fixed'}">
              <caption>등록 가능한 연락처 목록</caption>
              <colgroup>
                <col style="width:6%;" />
                <col style="width:5%;" />
                <col style="width:30%;" />
                <col style="width:14%;" />
                <col style="width:auto;" />
                <col style="width:12%;" />
              </colgroup>
              <tbody v-if="isTableLoading" class="h100p" style="position: static">
                <tr>
                  <td colspan="6" class="loading p0">
                    <HconLoading v-model="isLoadingShow" />
                  </td>
                </tr>
              </tbody>
              <tbody v-if="excelSuccessScrollList && excelSuccessScrollList.length > 0">
                <tr  :style="{ height: `${vScroll0.offset.value}px`}" class="hg0">
                  <td colspan="6" style="padding: 0; border: 0; line-height: 0; font-size: 0;" class="hg0"></td>
                </tr>
                <tr v-for="(item, index) in vScroll0.visibleItems.value" :key="`tab1-${item.currentNo}`" :style="{ height: `${ITEM_HEIGHT}px`}">
                  <td class="small">
                    <HconCheckBox type="default" :disabled="checkedDisabled" :checked="item.checked" @change="changeChecked(item.currentNo, $event)" :spanShowLabel="true" :spanA11yLabel="true" :label="`${item.rcvrGrpNm}${item.rcvrNm}${item.rcvrMblTelno}`" name="checkTable" :hide-label="true" :custom-class="'jc-r'" />
                  </td>
                  <td class="small">{{ vScroll0.startIndex.value + currentNo + index}}</td>
                  <td class="small">{{ item.rcvrGrpNm }}</td>
                  <td class="small">{{ item.rcvrNm }}</td>
                  <td class="small">{{ item.rcvrMblTelno }}</td>
                  <td class="small">
                    <div class="btn-hover"><button type="button" @click="handleDelete(item.currentNo)" class="btn btn-outline-gray xs">삭제</button></div>
                  </td>
                </tr>
                <tr :style="{ height: `${Math.max(0, vScroll0.totalHeight.value - vScroll0.offset.value - (vScroll0.visibleItems.value.length * ITEM_HEIGHT))}px`}" class="hg0">
                  <td colspan="6" style="padding: 0; border: 0;" class="hg0"></td>
                </tr>
              </tbody>
              <tbody v-else :style="excelSuccessScrollList.length > 0 ? 'position: absolute;' : 'position: static; height: 100%'">
                <tr>
                  <td colspan="6" class="nodata p0">현재 등록할 수 있는 연락처가 없습니다.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="button-box col2 jc-l mt20">
            <button type="button" class="btn btn-outline" @click="handleCheckedDelete">선택 삭제</button>
            <button type="button" class="btn btn-outline" @click="reUploadExcelRequest">엑셀 재업로드</button>
            <input ref="fileInputRef" type="file" accept=".xlsx, .xls" style="display: none;" @change="onFileChange" />
          </div>
          <div class="agree-box mt36" :class="{'error': isPrivacyAgreedError}">
            <HconCheckBox type="default" @change="changeCheckedPrivacyAgreed" :checked="false" label="개인정보 수집 및 이용에 동의합니다." name="allCheckBtn" labelClass="font-bold fs18 gap5" :showTextBefore="true" text="[필수]" textClass="font-normal text-red" :hide-label="false"/>
            <p v-if="(isPrivacyAgreedError && isPrivacyAgreedErrorType == 'null')" class="helper-text error pl31">{{HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9111)}}</p>
            <div class="box-gray mt18">
              <ul class="dot-list black">
                <li class="fs15">수집 항목 : 이름, 휴대전화번호</li>
                <li class="fs15">수집 이용·목적 : 연락처 등록/이용</li>
                <li class="fs15">
                  개인정보의 보유 및 이용기간 : <strong class="text-green">동의 철회 또는 탈퇴 후 30일</strong><br/>
                  <span class="text-gray02">*Hcon내 연락처 등록에 대해 거부하실 수 있으며, 거부 시 연락처 등록이 불가합니다.</span>
                </li>
              </ul>
            </div>
          </div>
        </template>
        <template v-if="messageListTab.v2.activeIndex === 1">
          <div class="mt40" :class="excelFailScrollList.length > 0 && isTableLoading === false ? 'pr10' : ''">
            <table class="tbl-type2">
              <caption>등록 불가능한 연락처 목록</caption>
              <colgroup>
                <col style="width:6%;" />
                <col style="width:5%;" />
                <col style="width:30%;" />
                <col style="width:14%;" />
                <col style="width:auto;" />
                <col style="width:12%;" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" class="xs"></th>
                  <th scope="col" class="xs">No</th>
                  <th scope="col" class="xs">연락처 그룹</th>
                  <th scope="col" class="xs">이름</th>
                  <th scope="col" class="xs">휴대전화번호</th>
                  <th scope="col" class="xs"></th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="relative pb1" :class="isTableLoading === true || excelFailScrollList.length > 0 ? 'scroll scroll2' : ''" ref="container1" @scroll="onScroll">
            <table class="tbl-type2" :class="excelFailScrollList.length > 0 && isTableLoading === false ? '' : 'h100p'" :style="{ transform: `translateY(${messageListTab.v2.activeIndex === 1 ? vScroll1.offset.value : 0}px)`, tableLayout: 'fixed'}">
              <caption>등록 불가능한 연락처 목록</caption>
              <colgroup>
                <col style="width:6%;" />
                <col style="width:5%;">
                <col style="width:30%;">
                <col style="width:14%;">
                <col style="width:auto;">
                <col style="width:12%;">
              </colgroup>
              <tbody v-if="isTableLoading" class="hg360" style="position: static">
                <tr>
                  <td colspan="6" class="loading p0">
                    <HconLoading v-model="isLoadingShow" />
                  </td>
                </tr>
              </tbody>
              <tbody v-if="excelFailScrollList && excelFailScrollList.length > 0">
                <tr :style="{ height: `${vScroll1.offset.value}px`}" class="hg0">
                  <td colspan="6" style="padding: 0; border: 0; line-height: 0; font-size: 0;" class="hg0"></td>
                </tr>
                <tr v-for="(item, index) in vScroll1.visibleItems.value" :key="`tab2-${item.id}`" :style="{ height: `${ITEM_HEIGHT}px`}">
                  <td class="small"></td>
                  <td class="small">{{ vScroll1.startIndex.value + currentNo + index }}</td>
                  <td class="small">{{ item.rcvrGrpNm }}</td>
                  <td class="small">{{ item.rcvrNm }}</td>
                  <td class="small">{{ item.rcvrMblTelno }}</td>
                  <td class="small"></td>
                </tr>
                <tr :style="{ height: `${Math.max(0, vScroll1.totalHeight.value - vScroll1.offset.value - (vScroll1.visibleItems.value.length * ITEM_HEIGHT))}px`}" class="hg0">
                  <td colspan="6" style="padding: 0; border: 0;" class="hg0"></td>
                </tr>
              </tbody>
              <tbody v-else :style="excelFailScrollList.length > 0 ? 'position: absolute;' : 'position: static; height: 100%'">
                <tr>
                  <td colspan="6" class="nodata">현재 등록이 불가능한 연락처가 없습니다.</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="box-gray mt28">
            <ul class="dot-list">
              <li>업로드한 엑셀 파일에 중복된 휴대전화번호가 포함되어 있어 등록할 수 없습니다.</li>
              <li>이미 연락처 관리에 저장된 번호가 포함된 경우에도 등록이 제한됩니다.</li>
              <li>등록을 원하시면 중복된 번호를 삭제 또는 수정한 후 다시 업로드해 주세요.</li>
            </ul>
          </div>
        </template>
      </div>
      <div class="popup-footer jc-c">
        <div class="button-box col2">
          <button type="button" v-show="messageListTab.v2.activeIndex === 0" @click="receiveTelnoRegist" class="btn md">동의하고 등록</button>
        </div>
      </div>
    </BasePopup>
  </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import HconCheckBox from '@/components/com/HconComPCCheckbox.vue'
import HconLoading from '@/components/com/HconComPCLoading.vue';
import BasePopup from '@/components/com/HconComBasePopup.vue'
import { usePopup } from '@/composables/hconUsePopup'
import type { RegistReceiveTelnoAvailableDto } from '~/types/mypage/backend-dto-types';
import { COMMON_CODE, MEMBER_CODE, ORDER_CODE} from '~/constants/hconMessageConstants';
import { HconCommonRegExp } from '@/constants/hconRegexConstants'

// 팝업
const {showAlert, showConfirm} = usePopup()

// 연락처 대량 등록 팝업
const isContactUpdatePopupOpen = ref(false)

const isChkError = ref(true)

// 팝업 열림
const handleOpen = () => {
  isContactUpdatePopupOpen.value = true
}

onMounted(async() => {

  // 팝업 열림
  handleOpen();

  // 부모에서 넘겨준 파일 파싱
  parseExcel(props.file, "UPLOAD");

  // containerHeight 값 세팅
  if (container0.value) {
    vScroll0.setContainerHeight(container0.value)
  }
  else if(container1.value) {
    vScroll1.setContainerHeight(container1.value)
  }

})

// 부모컴포넌트로부터 받은 값
const props = defineProps<{
  file: File | null
}>()

// 부모컴포넌트에 넘길 값
const emit = defineEmits(['success','cancel']);

// [X] 버튼 클릭 > 팝업 닫힘
const handleClose = () => {
  emit('cancel');
  isContactUpdatePopupOpen.value = false;
}

// [동의하고 등록] 버튼 클릭 > 값 부모창에 전달 및 팝업 닫힘
const closePopup = () => {
  emit('success', 'Y');
  isContactUpdatePopupOpen.value = false;
}

// 연락처 No
const currentNo = ref<number>(1)
// 개별 체크박스 disabled 변수
const checkedDisabled = ref(false);

// 개인정보 수집 및 이용 동의 여부
const checkedPrivacyAgreed = ref("N")
const isPrivacyAgreedError = ref(false)
const isPrivacyAgreedErrorType = ref()

// 행 전체 선택 
const checkedAll = computed(() => {
  return excelSuccessList.value.length > 0 && excelSuccessList.value.every(item => item.checked)
})

// 행 전제 선택 갯수
const checkedAllCount = computed(() => {
  return checkedAll.value === true ? excelSuccessList.value.length : excelSuccessList.value.filter(item => item.checked).length
})

// 행 개별 선택 change 이벤트 
const changeChecked = (isCheckedNo:number, isCheckedStatus:boolean) => {
  const checkedNo = excelSuccessList.value.find(item => item.currentNo == isCheckedNo)
  if(checkedNo) {
    checkedNo.checked = isCheckedStatus
  } 
}

// 행 전체 선택 change 이벤트 
const changeCheckedAll = (isCheckedStatus:boolean) => {
  if(excelSuccessList.value) {
    excelSuccessList.value.forEach(item => {
    item.checked = isCheckedStatus
  })
  // 전체 선택 시 개별 선택 비활성화 처리
  checkedDisabled.value = isCheckedStatus;
  }
}

// 중복여부 N인 데이터(rcvrMblTelno 값) => 기 등록된 휴대전화번호 확인 시 서버에 보낼 데이터
const checkedList = computed(() => {
  return excelList.value.filter(item => item.duplicate == false).map((item: any) => ({
    rcvrMblTelno: item.rcvrMblTelno.replace(/-/g,'')
  }))
})

// 연락처 삭제
const deleteReceiveTelno = (currentNo: number) => {
  if(currentNo) {
    excelSuccessList.value = excelSuccessList.value.filter(item => item.currentNo != currentNo)
  }
}

// 선택한 행들 목록(currentNo 값)
const checkedData = computed(() => {
  return excelSuccessList.value.filter(item => item.checked == true).map(item => item.currentNo)
})

// 연락처 선택 삭제
const deleteReceiveTelnoList = () => {
  if(checkedData.value.length > 0) {
    excelSuccessList.value = excelSuccessList.value.filter(item => !checkedData.value.includes(item.currentNo))
  }
}

// 개인정보 수집 및 이용 동의 여부 change 이벤트 
const changeCheckedPrivacyAgreed = (isCheckedPrivacyAgreed : boolean) => {
  checkedPrivacyAgreed.value = isCheckedPrivacyAgreed ? 'Y' :'N'
}

// validate checkFlag
const checkFlag = ref(false);

// 유효성 체크
const validateCheck = () => {

  isPrivacyAgreedError.value = false
  isPrivacyAgreedErrorType.value = ""

  // 연락처 미선택 시 
  if(checkedData.value.length == 0) {
    showAlert({ 
      title: '연락처 미선택',
      message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9180)
    });
    return checkFlag.value = false;
  }

  // 개인정보 수집 및 이용동의 여부 Null 체크
  if(checkedPrivacyAgreed.value == 'N') {
    isPrivacyAgreedError.value = true
    isPrivacyAgreedErrorType.value = 'null'  
    return checkFlag.value = false;
  }

  isPrivacyAgreedError.value = false
  isPrivacyAgreedErrorType.value = ""

  return checkFlag.value = true;

}

// 재업로드 데이터
const sendListfile = ref<File | null>(null);
const fileInputRef = ref<HTMLInputElement | null>(null);

// 엑셀 재업로드 버튼 click 이벤트(윈도우탐색기 호출)
const reUploadExcelRequest = () => {
  showConfirm({
    title: '엑셀 재업로드', 
    message : HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9179),
    onConfirm: () => {fileInputRef.value?.click()},
    cancelText: '취소'
  })
}

// 파일 선택 이벤트
const onFileChange = (e:Event) => {
  const target = e.target as HTMLInputElement;
  if(!target.files || target.files.length === 0) return;
  
  // 선택한 파일
  const selectedFile = target.files[0];

  // 엑셀 파일 확장자 체크
  const isExcel = selectedFile.name.endsWith('.xlsx') || selectedFile.name.endsWith('.xls');
  if (!isExcel) {

    (document.activeElement as HTMLInputElement)?.blur()

    showAlert({ 
      title: '잘못된 파일',
      message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9083)
    });
    
    if(fileInputRef.value) {
      fileInputRef.value.value = ""
    }

    return false
  }
  else {
    sendListfile.value = selectedFile;
    parseExcel(sendListfile.value, "REUPLOAD");
    target.value = '';
  }
}

interface ExcelListData {
 currentNo: number,
 rcvrGrpNm: string,
 rcvrNm: string,
 rcvrMblTelno: string,
 duplicate: boolean,
 checked: boolean
}

// 원본 데이터(처음 업로드 시 데이터)
const excelList = ref<ExcelListData[]>([])
// 등록 가능 여부 확인 데이터
const registAvailableList = ref<RegistReceiveTelnoAvailableDto[]>([])
// 등록 가능 데이터(중복 휴대전화번호 제거 + 이미 DB에 저장된 휴대전화번호 제거)
const excelSuccessList = ref<ExcelListData[]>([])
// 등록 가능 데이터 => 화면 표시용(20건씩 페이징 처리)
const excelSuccessScrollList = ref<ExcelListData[]>([])
// 등록 불가 데이터(중복 휴대전화번호 + 이미 DB에 저장된 휴대전화번호)
const excelFailList = ref<ExcelListData[]>([])
// 등록 불가 데이터 => 화면 표시용(20건씩 페이징 처리)
const excelFailScrollList = ref<ExcelListData[]>([])
// 등록할 데이터
const registList = ref<ExcelListData[]>([])

// 업로드한 파일 화면에 세팅
const parseExcel = async (file:File | null, uploadType:String) => {

  if(uploadType == "UPLOAD" && !props.file) return

  if(uploadType == "REUPLOAD" && !file) return 

  if (import.meta.server) return;
  // 동적 import 생성
  // 클라이언트에서만 라이브러리 로딩
  const XLSX = await import('xlsx-js-style');
  
  const reader = new FileReader()

  reader.onload = async (e) => {

    const data = e.target?.result
    const workbook = XLSX.read(data, {type:'binary'})
    const sheetName = workbook.SheetNames[0]
    const sheet = workbook.Sheets[sheetName]

    const rows = XLSX.utils.sheet_to_json<any[]>(sheet, {range:6, header:1})
    
    // 빈행 제외
    const validRows = rows.filter(row => {
      const hasData = (row[0]?.length > 0) || (row[1]?.length > 0) || (row[2]?.length > 0)
      return hasData
    })

    // 재업로드 시 데이터 배열 초기화
    if(uploadType == "REUPLOAD") {
      checkedDisabled.value = false
      excelList.value = []
      registAvailableList.value = []
      excelSuccessList.value = []
      excelSuccessScrollList.value = []
      excelFailList.value = []
      excelFailScrollList.value = []
      isSuccessLastPage.value = false
      isFailLastPage.value = false
      vScroll0.setScrollTop(0)
      vScroll1.setScrollTop(0)
    }

    // 빈 파일 확인
    if(validRows.length == 0) {
      showAlert({
        title: '빈 파일',
        message: HconCommonUtils.format.message(ORDER_CODE.ALT_HCON_9087)
      });
      return false
    }
    
    // 연락처그룹, 이름, 휴대전화번호 외 컬럼 존재 여부 체크
    const invalidColumn = validRows.some(row =>
      row.slice(3).some(cell => cell !== '')
    )
    
    // 엑셀 양식 일치 확인
    if(invalidColumn) {
      showAlert({
        title: '양식 불일치',
        message: HconCommonUtils.format.message(COMMON_CODE.ALT_HCON_9082)
      });
      return false
    }

    // 연락처 중복행 갯수
    const rcvrMblTelnoCounts = new Map();

    // 연락처 중복 행 갯수 세팅
    validRows.forEach(row => {
      const rcvrMblTelno = formatPhone(String(row[2]))
      if(rcvrMblTelno && rcvrMblTelno != undefined && rcvrMblTelno != null && rcvrMblTelno.trim() != "") {
        if(!rcvrMblTelnoCounts.has(rcvrMblTelno)) {
          rcvrMblTelnoCounts.set(rcvrMblTelno, 1)
        }
        else {
          rcvrMblTelnoCounts.set(rcvrMblTelno, rcvrMblTelnoCounts.get(rcvrMblTelno) + 1)
        }    
      }
    })
    
    validRows.forEach((row, index) => {
      
      // 휴대전화번호 중복 체크
      const isDuplicate = rcvrMblTelnoCounts.get(formatPhone(String(row[2]) || "") || 0) > 1
      // 이름 형식 체크
      const isNameRegexMatch = HconCommonRegExp.USER_NAME_REGEX.test(String(row[1]).trim() || "")
      // 휴대전화번호 형식 체크
      const isTelnoRegexMatch = HconCommonRegExp.Mbl_Telno_REGEX_NO_DASH.test(formatPhone(String(row[2]) || "").trim().replace(/-/g,'') || "")
      // 이름, 휴대전화번호 필수 값 체크
      const isRequiredValueExist = String(row[0] || "").trim() && (!String(row[1] || "").trim() || !String(row[2] || "").trim())

      // 원본 데이터 push
      excelList.value.push ({
        currentNo: index + 1, // 순번
        rcvrGrpNm: String(row[0] || '').trim(), // 연락처 그룹
        rcvrNm: String(row[1] || '').trim(), // 이름
        rcvrMblTelno: formatPhone(String(row[2] || '').trim()), // 휴대전화번호
        duplicate: isDuplicate, // 중복여부
        checked: false // 체크여부(초기 값은 전부 false)
      })

      // 등록 가능 데이터 push
      if(!isDuplicate && isNameRegexMatch && isTelnoRegexMatch && !isRequiredValueExist) {
        excelSuccessList.value.push({
          currentNo: index + 1, // 순번
          rcvrGrpNm: String(row[0] || '').trim(), // 연락처 그룹
          rcvrNm: String(row[1] || '').trim(), // 이름
          rcvrMblTelno: formatPhone(String(row[2] || '').trim()), // 휴대전화번호
          duplicate: isDuplicate, // 중복여부
          checked: false // 체크여부
        })
      }
      // 등록 불가 데이터 push
      else if(isDuplicate || !isNameRegexMatch || !isTelnoRegexMatch || isRequiredValueExist) {
        excelFailList.value.push({
          currentNo: index + 1, // 순번
          rcvrGrpNm: String(row[0] || '').trim(), // 연락처 그룹
          rcvrNm: String(row[1] || '').trim(), // 이름
          rcvrMblTelno: String(row[2] || '').trim(), // 휴대전화번호
          duplicate: isDuplicate, // 중복여부
          checked: false // 체크여부
        })
      }
    })

    // 등록가능 여부 API 호출(기존에 등록된 연락처 확인)
    await receiveTelnoRegistAvailable()
    
    // 등록가능 여부 반영(Y)
    excelSuccessList.value = excelSuccessList.value.filter(item => {
      return registAvailableList.value.filter(item => item.registAvailableYn == 'Y').map(item => formatPhone(item.rcvrMblTelno)).includes(item.rcvrMblTelno)
    })
    
    // 페이징 초기 데이터 세팅(기본 20건)
    excelSuccessScrollList.value = excelSuccessList.value.slice(0,20)

    // 등록가능 여부 반영(N)
    excelFailList.value = [
      ...excelFailList.value,
      ...excelList.value.filter(item => {
      return registAvailableList.value.filter(item => item.registAvailableYn == 'N').map(item => formatPhone(item.rcvrMblTelno)).includes(item.rcvrMblTelno)
    })
    ].sort((a:any,b:any) => Number(a.currentNo) - Number(b.currentNo))

    // 페이징 초기 데이터 세팅(기본 20건)
    excelFailScrollList.value = excelFailList.value.slice(0,20)
  }

  if(uploadType == "UPLOAD"  && props.file) {
    reader.readAsArrayBuffer(props.file)
  }
  else if(uploadType == "REUPLOAD"  && file) {
    reader.readAsArrayBuffer(file)
  }
}

// 연락처 형식 체크
const formatPhone = (val:string | number) => {
  if(!val || val == undefined || val == null) return ""

  let cleanVal = String(val).replace(/[^0-9]/g,"")

  // 101235678(9자리) or 1012345678(10자리) 맨 앞에 0이 없이 들어온 경우 0을 붙여줌
  if((cleanVal.length == 9 || cleanVal.length == 10) && !cleanVal.startsWith('0')) {
    cleanVal = '0' + cleanVal
  }

  return cleanVal.replace(/^(\d{3})(\d{3,4})(\d{4})$/, "$1-$2-$3")

}

const fetchBuilder  = useHconFetchBuilder();

// 연락처 대량 등록 가능여부 API 호출
const receiveTelnoRegistAvailable = async () => {

  if(excelList.value.length > 0) {
    const fetchBuilderResult = 
    await fetchBuilder.post<AjaxResult<RegistReceiveTelnoAvailableDto[]>>('/api/v1/mypage/receivePerson/receiveTelno-regist-available')
    .body(checkedList)
    .progressMessage("잠시만 기다려주세요...")
    .preventErrorNotify()
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode == '200') {
        registAvailableList.value = result.data
      }
    })
    .catch((error) => {
      // 응답코드가 200이 아닌경우
      if(error.resultCode != '200') {
        showAlert(error.resultMessage)
      }
    })
  }
}

// 연락처 대량 등록 API 호출
const receiveTelnoRegist = async () => {
  
  validateCheck();

  if(checkFlag.value == true) {
    // 등록할 연락처 목록 세팅
    if(checkedAll.value === true) {
      registList.value = excelSuccessList.value
      .map(item => ({
        ...item,
        rcvrMblTelno: item.rcvrMblTelno.replace(/-/g,'')
      }))
    }
    else {
      registList.value = excelSuccessScrollList.value
      .filter(item => checkedData.value.includes(item.currentNo))
      .map(item => ({
        ...item,
        rcvrMblTelno: item.rcvrMblTelno.replace(/-/g,'')
      }))
    }
    
    const fetchBuilderResult = 
    await fetchBuilder.post<AjaxResult<boolean>>('/api/v1/mypage/receivePerson/receiveTelno-regist-list')
    .body({
      checkedList: registList.value,
      tncYn: checkedPrivacyAgreed.value
    })
    .progressMessage("잠시만 기다려주세요...")
    .preventErrorNotify()
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode == '200') {
        if(result.data == true) {
          showAlert({
            title: '알림', 
            message : HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9099),
            onConfirm: () => {closePopup()}
          })
        } 
      }
    })
    .catch((error) => {
      // 응답코드가 200이 아닌경우
      if(error.resultCode != '200') {
        showAlert(error.resultMessage)
      }
    })

  }

}

// 가상 스크롤 변수 선언
const ITEM_HEIGHT = 40
const isLoading = ref(false)
const isSuccessLastPage = ref(false)
const isFailLastPage = ref(false)
const vScroll0 = useVirtualScroll(excelSuccessScrollList, ITEM_HEIGHT)
const vScroll1 = useVirtualScroll(excelFailScrollList, ITEM_HEIGHT)

const container0 = ref<HTMLElement | null>(null)
const container1 = ref<HTMLElement | null>(null)

// scroll 이벤트
const onScroll = (event: Event) => {
  if(messageListTab.value['v2'].activeIndex == 0) {
    vScroll0.handleScroll(event, () => {
      if (!isLoading.value && !isSuccessLastPage.value) {
        loadMoreData()
      }
    })
  }
  else if(messageListTab.value['v2'].activeIndex == 1) {
    vScroll1.handleScroll(event, () => {
      if (!isLoading.value && !isFailLastPage.value) {
        loadMoreData()
      }
    })
  }
}

// 데이터 로드 (20건씩)
const loadMoreData = () => {

  if(isLoading.value) return
  
  isLoading.value = true
  isTableLoading.value = true
  isLoadingShow.value = true

  // 첫번째 탭
  if(messageListTab.value['v2'].activeIndex == 0 && !isSuccessLastPage.value) {

    const start = excelSuccessScrollList.value.length
    const nextDatas = excelSuccessList.value.slice(start, start + 20)

    if(nextDatas.length > 0) {
      excelSuccessScrollList.value.push(...nextDatas)
    }

    if(excelSuccessScrollList.value.length >= excelSuccessList.value.length) {
      isSuccessLastPage.value = true
    }
  }
  // 두번째 탭
  else if (messageListTab.value['v2'].activeIndex == 1 && !isFailLastPage.value) {

    const start = excelFailScrollList.value.length
    const nextDatas = excelFailList.value.slice(start, start + 20)

    if(nextDatas.length > 0) {
      excelFailScrollList.value.push(...nextDatas)
    }

    if(excelFailScrollList.value.length >= excelFailList.value.length) {
      isFailLastPage.value = true
    }
  }

  isLoading.value = false
  isTableLoading.value = false
  isLoadingShow.value = false
}

// 로딩 상태값
const isTableLoading = ref(false)
const isLoadingShow = ref(false)

// 삭제 버튼 클릭 시
const handleDelete = async (currentNo: number) => {
  showConfirm({
    title: '연락처 삭제',
    message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9098),
    onConfirm: () => {deleteReceiveTelno(currentNo)},
    cancelText: '취소'
  })
}

// 선택 삭제 버튼 클릭 시
const handleCheckedDelete = async () => {
  // 연락처 미선택 시 
  if(checkedData.value.length == 0) {
    showAlert({ 
      title: '연락처 미선택',
      message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9180)
    });
    return checkFlag.value = false;
  }
  else {
    showConfirm({
      title: '연락처 삭제',
      message: HconCommonUtils.format.message(MEMBER_CODE.ALT_HCON_9098),
      onConfirm: () => {deleteReceiveTelnoList()},
      cancelText: '취소'
    })
  }

}

// 탭
const messageListTab = ref({
  v2: {
    items: [
      {text: `등록 가능 (${excelSuccessList.value.length})`},
      {text: `등록 불가 (${excelFailList.value.length})`},
    ],
    activeIndex: 0
  },
});

// 등록 가능 목록 변경 감지
watch(excelSuccessList, (newList) => {
  messageListTab.value['v2'].items[0].text = `등록 가능 (${excelSuccessList.value.length})`
  // 페이징 초기 데이터 세팅(기본 20건)
  excelSuccessScrollList.value = excelSuccessList.value.slice(0,20)
  isSuccessLastPage.value = false

})

// 등록 불가 목록 변경 감지
watch(excelFailList, (newList) => {
  messageListTab.value['v2'].items[1].text = `등록 불가 (${excelFailList.value.length})`
  // 페이징 초기 데이터 세팅(기본 20건)
  excelFailScrollList.value = excelFailList.value.slice(0,20)
  isFailLastPage.value = false
  
})

// 탭 유형
type TabVersion = 'v2';

// 탭 클릭 핸들러
const handleTabClick = (version: TabVersion, index: number) => {

  messageListTab.value[version].activeIndex = index;

  onInitalizeValues()
}

// 변수 값 초기화 이벤트
const onInitalizeValues = () => {

// 개인정보 수집 및 이용 동의 여부 초기화
checkedPrivacyAgreed.value = "N"
isPrivacyAgreedError.value = false
isPrivacyAgreedErrorType.value = ""

// 로딩 값 초기화
isLoading.value = false

// 마지막 페이지 여부 초기화
isSuccessLastPage.value = false
isFailLastPage.value = false

// 화면용 데이터 초기화
excelSuccessScrollList.value = excelSuccessList.value.slice(0,20)
excelFailScrollList.value = excelFailList.value.slice(0,20)

// 스크롤 값 초기화
vScroll0.setScrollTop(0)
vScroll1.setScrollTop(0)

if(container0.value) {
  vScroll0.setContainerHeight(container0.value)
  container0.value.scrollTop = 0
}
else if(container1.value) {
  vScroll1.setContainerHeight(container1.value)
  container1.value.scrollTop = 0
}

}

</script>
<style lang="scss">
@use "@/assets/scss/pc/mypage-hcon.scss" as *;
</style>